import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from './history';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import importReducer from '../features/import/redux/reducer';
import templateReducer from '../features/template/redux/reducer';
import pluginReducer from '../features/plugin/redux/reducer';
import appSettingReducer from '../features/app-setting/redux/reducer';
import dataConnectorReducer from '../features/data-connector/redux/reducer';
import externalApiReducer from '../features/external-api/redux/reducer';
import tutorialReducer from '../features/tutorial/redux/reducer';
import collectionsReducer from '../features/collections/redux/reducer';
import eventsReducer from '../features/events/redux/reducer';
import projectOnBoardReducer from '../features/project-on-board/redux/reducer';
import knowledgeBaseReducer from '../features/knowledge-base/redux/reducer';
import webhookReducer from '../features/webhook/redux/reducer';
import loggerReducer from '../features/logger/redux/reducer';
import onBoardingReducer from '../features/on-boarding/redux/reducer';
import scheduleReducer from '../features/schedule/redux/reducer';
import customComponentReducer from '../features/custom-component/redux/reducer';
import permissionReducer from '../features/permission/redux/reducer';
import deploymentSettingReducer from '../features/deployment-setting/redux/reducer';
import aiPromptBuilderReducer from '../features/ai-prompt-builder/redux/reducer';

const reducerMap = {
  router: connectRouter(history),
  home: homeReducer,
  common: commonReducer,
  import: importReducer,
  template: templateReducer,
  plugin: pluginReducer,
  appSetting: appSettingReducer,
  dataConnector: dataConnectorReducer,
  externalapi: externalApiReducer,
  tutorial: tutorialReducer,
  collections: collectionsReducer,
  events: eventsReducer,
  projectOnBoard: projectOnBoardReducer,
  knowledgeBase: knowledgeBaseReducer,
  webhook: webhookReducer,
  logger: loggerReducer,
  onBoarding: onBoardingReducer,
  schedule: scheduleReducer,
  customComponent: customComponentReducer,
  permission: permissionReducer,
  deploymentSetting: deploymentSettingReducer,
  aiPromptBuilder: aiPromptBuilderReducer,
};

export default combineReducers(reducerMap);
